/* 
For ADA compliance - only including one anchor tag per content block + using JS for remaining elements that need to link mouse users 
ex. where whole cards should be clickable
*/
document.querySelectorAll('[data-featured-link]').forEach((nonAnchorLink) => {
  nonAnchorLink.addEventListener('click', () => {
    const link = nonAnchorLink.getAttribute('data-featured-link')
    window.location.href = link
  })
})
